// Toggle the pledge/offer/message "support" feature. Set back to true to re-enable.
// When false: swipe-right adds a project to Saved instead of opening the support sheet,
// and all support entry points (sticky bar, action button, "My support" nav) are hidden.
export const SUPPORT_ENABLED = false;
